export const formatSublimitsData = data => {
  return data.map(({ name, id }) => ({ value: id, title: name, key: id }));
};
